import { z } from 'zod'

/**
 * OCR スタンプ獲得失敗時（400）のレスポンスボディ。
 * バックエンドは { error: { code, ocrId, maxRetry } } でネストして返す。
 * 後方互換のためトップレベルの { ocrId, code } も許容する。
 */
export const OcrStampAcquireErrorBodySchema = z.object({
  code: z.string().optional(),
  ocrId: z.number().nullable().optional(),
  maxRetry: z.number().nullable().optional(),
  error: z
    .object({
      code: z.string().optional(),
      ocrId: z.number().nullable().optional(),
      maxRetry: z.number().nullable().optional(),
    })
    .optional(),
})
export type OcrStampAcquireErrorBody = z.infer<typeof OcrStampAcquireErrorBodySchema>

/**
 * OCR 補填申請フォームの項目定義。
 * inputType は text / date / number のみ。options は OCR補填では常に null。
 */
export const OcrApplicationFieldSchema = z.object({
  id: z.number(),
  fieldKey: z.string(),
  label: z.string(),
  inputType: z.enum(['text', 'date', 'number']).catch('text'),
  isRequired: z.boolean(),
  sortOrder: z.number(),
  options: z.array(z.string()).nullable(),
})
export type OcrApplicationField = z.infer<typeof OcrApplicationFieldSchema>

/**
 * OCR 補填申請フォーム設定取得レスポンス
 * GET /api/v2/ocr/scan/request/{ocrId}
 */
export const OcrScanRequestGetResponseSchema = z.object({
  ocrId: z.number(),
  allowApplication: z.boolean(),
  applicable: z.boolean(),
  messageMaxLength: z.number(),
  fieldValueMaxLength: z.number(),
  fields: z.array(OcrApplicationFieldSchema),
})
export type OcrScanRequestGetResponse = z.infer<typeof OcrScanRequestGetResponseSchema>

/**
 * OCR 補填申請リクエストボディ
 * POST /api/v2/ocr/scan/request
 */
export const OcrScanRequestSchema = z.object({
  ocrId: z.number(),
  message: z.string().optional(),
  fields: z.record(z.string(), z.string()).optional(),
})
export type OcrScanRequest = z.infer<typeof OcrScanRequestSchema>
